import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminCosmeticStatus } from '@web/shared/module/cosmetic';

@Injectable({
  providedIn: 'root',
})
export class AdminCosmeticStatusProviderService {
  private readonly entries = new Map<AdminCosmeticStatus, string>([
    [AdminCosmeticStatus.Draft, 'Szkic'],
    [AdminCosmeticStatus.Private, 'Prywatna'],
    [AdminCosmeticStatus.Public, 'Publiczna'],
  ]);

  public labelFor(status: AdminCosmeticStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminCosmeticStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
